import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ACCOUNT_LEDGER_FEATURE_KEY, AccountLedgerState } from '../reducer/account-ledger.reducer';

const feature = createFeatureSelector<AccountLedgerState>(ACCOUNT_LEDGER_FEATURE_KEY);

export const selectAccountLedgerPage = createSelector(feature, (s) => s.page);
export const selectAccountLedgerRows = createSelector(feature, (s) => s.rows);
export const selectAccountLedgerLoading = createSelector(feature, (s) => s.loading);
export const selectAccountLedgerLoadingMore = createSelector(feature, (s) => s.loadingMore);
export const selectAccountLedgerError = createSelector(feature, (s) => s.error);
export const selectAccountLedgerCursor = createSelector(feature, (s) => s.page?.nextCursor ?? null);
export const selectAccountLedgerCanLoadMore = createSelector(selectAccountLedgerCursor, (cursor) => cursor !== null);
